<template>

  <v-container fluid>

    <im-page-title
      title="Inventar"
    />

    <im-sheet-toolbar
      :from.sync="query.from"
      :until.sync="query.until"
      :contract.sync="query.contract"
      :types.sync="types"
    />

    <div class="ma-3">
      <v-progress-linear :color="loading ? 'primary' : `grey`" :indeterminate="loading" rounded/>
    </div>

    <im-sheet-card
      v-for="room in rooms"
      :key="room.id"
      :period="sheet.period"
      :days="sheet.days"
      :room="room"
      :types="types"
      :sheet="sheet.sheet"
      ref="sheet-card"
      @select="select"
      @scroll="scroll"
      @inventory="inventory"
      @pricing="pricing"
    />

    <im-sheet-inventory-dialog
      ref="inventory_dialog"
      :rooms="rooms"
      :room="room"
      :contract="query.contract"
      :dialog.sync="inventory_dialog"
      @success="getSheet"
    />

    <im-sheet-pricing-dialog
      ref="pricing_dialog"
      :rooms="rooms"
      :rates="rates"
      :room="room"
      :rate="rate"
      :dialog.sync="pricing_dialog"
      @success="getSheet"
    />

  </v-container>

</template>


<script>

  import sheet_repository from '@/repositories/sheet-repository';

  export default {

    components: {
      'im-page-title': () => import('@/components/ThePageTitle'),
      'im-sheet-toolbar': () => import('@/components/Sheet/SheetToolbar'),
      'im-sheet-card': () => import('@/components/Sheet/SheetCard'),
      'im-sheet-inventory-dialog': () => import('@/components/Sheet/Dialogs/SheetInventoryDialog'),
      'im-sheet-pricing-dialog': () => import('@/components/Sheet/Dialogs/SheetPricingDialog'),
    },

    data() {
      return {

        loading: false,
        inventory_dialog: false,
        pricing_dialog: false,

        selected: null,

        sheet: null,

        room: [],
        rooms: {},

        rate: [],
        rates: [],

        query: {
          from: this.$moment().format('YYYY-MM-DD'),
          until: this.$moment().add(14, 'days').format('YYYY-MM-DD'),
          contract: null,
        },

        types: ['cost', 'sale', 'offer']

      }
    },

    watch: {
      query: {
        handler: 'getSheet',
        immediate: true,
        deep: true
      },
    },

    methods: {

      select: function (room) {
        this.selected = room;
      },

      scroll: function () {
        this.$refs['sheet-card'].forEach(item => {
          if (item.room.id === this.selected.id) { return }
          item.$refs['sheet-wrapper'].scrollLeft = event.target.scrollLeft;
        });
      },

      inventory: function (room) {
        this.$refs['inventory_dialog'].resetDialog();
        this.inventory_dialog = true;
        this.room.splice(0, this.room.length);
        this.room.push(room.id);
      },

      pricing: function (room) {
        this.$refs['pricing_dialog'].resetDialog();
        this.pricing_dialog = true;

        this.room.splice(0, this.room.length);
        this.room.push(room.id);
        this.rate.splice(0, this.rate.length);
        this.rate.push(_.first(room.rate_plans).id);

        this.rates.splice(0, this.rates.length);
        this.rooms[room.id].rate_plans.forEach(rate => {
          this.rates.push(rate);
        });
      },

      getSheet: async function () {

        this.inventory_dialog = false;
        this.pricing_dialog = false;

        if (!this.query.from || !this.query.until || !this.query.contract)
          return;

        this.loading = true;
        this.sheet = await sheet_repository.getSheet(this.$route.params.hotel, this.query);
        this.loading = false;

        if (this.rooms) {
          Object.entries(this.rooms).forEach(([key, room]) => {
            room.rate_plans.forEach(rate => {
              if (rate.show) {
                this.sheet.room_types[key].rate_plans.forEach(rate_plan => {
                  if (rate.show && rate.id === rate_plan.id)
                    this.$set(rate_plan, 'show', rate.show);
                })
              }
            })
          });
        }

        this.rooms = this.sheet.room_types;
      }

    }

  }
</script>